<template>
  <div>
    <button v-if="buyNow" class="buy-now" :class="btnStyleGenerate" @click="clickToCart">
      <span>{{ pzBuyNow }}</span>
    </button>
    <button v-if="!buyNow" class="add-cart" :class="btnStyleGenerate" @click="clickToCart">
      <span class="now-text">{{ btnDescriptionGenerate }}</span>
      <span class="added-text">已加入購物車</span>
    </button>
  </div>
</template>

<script>
import $ from 'jquery';
import AlertDialog from '@global/helpers/alertDialog';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'BuyButton',
  props: {
    buyNow: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState('shopContent', ['btnStyleGenerate', 'btnDescriptionGenerate', 'pzBuyNow']),
  },
  methods: {
    ...mapActions('shopContent', ['addToCart']),
    clickToCart() {
      this.addToCart()
        .then((resolve) => {
          if (resolve === undefined) return;
          const { code, response } = resolve;

          switch (code) {
            case 200:
              if (!this.buyNow) {
                $('.now-text').css('display', 'none');
                $('.added-text').css('display', 'block');

                setTimeout(() => {
                  $('.added-text').css('display', 'none');
                  $('.now-text').css('display', 'block');
                }, 700);
              }

              $('#lb-add-to-cart').modal('show');

              setTimeout(() => {
                $('#lb-add-to-cart').modal('hide');
              }, 2000);

              if (this.buyNow) {
                $('#lb-add-to-cart').modal('show');

                setTimeout(() => {
                  $('#lb-add-to-cart').modal('hide');
                  window.location.href = '/zh-tw/checkout';
                }, 2000);
              }
              break;
            case 205:
              AlertDialog.alert('商品已售完', () => {
                window.location.reload();
              });
              break;
            default:
              AlertDialog.alert(response);
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};
</script>
